var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionTemplate',{ref:"sundry-payment",attrs:{"screenJson":_vm.getScreenJson,"setLoading":_vm.setLoading,"localDataGrid":false,"backButtonRoute":_vm.backButtonRoute,"data-model":_vm.dataModel,"backRouteAppend":undefined,"isLoaded":_vm.loaded,"getHeaderToolbar":_vm.getHeaderToolbar}})
}
var staticRenderFns = []

export { render, staticRenderFns }